import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useInviteMutation } from '@platform/state/api';
import type { IInviteFormProps } from './IInviteFormProps';
import { ROLES } from './roles';

const EMAIL = /^\S+@\S+\.\S+$/;

/**
 * Форма «Запросити за ел. поштою» (прототип v4 G:L2710): поле адреси 36px, роль (типово — учасник), «Надіслати запрошення»; перевірка
 * адреси, повтору учасника й запрошення («Уже є учасником.», «Уже запрошено.»). Сервер без API запрошень — форма вимкнена з поясненням.
 */
export function InviteForm({ ws, invited, memberEmails, available }: IInviteFormProps) {
  const { t } = useTranslation();
  const [invite, { isLoading }] = useInviteMutation();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Member');
  const [error, setError] = useState('');
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const value = email.trim().toLowerCase();
    if (!EMAIL.test(value)) return setError(t('membersPage.invalidEmail'));
    if (memberEmails.includes(value)) return setError(t('membersPage.alreadyMember'));
    if (invited.includes(value)) return setError(t('membersPage.alreadyInvited'));
    invite({ ws, body: { email: value, role } }).unwrap()
      .then(() => { setEmail(''); setError(''); })
      .catch((err: { message?: string }) => setError(err?.message ?? t('app.error')));
  };
  return (
    <form className="mb-form" onSubmit={submit}>
      <label className="mb-field mb-field--grow">
        <span className="mb-field__label">{t('membersPage.inviteEmail')}</span>
        <input className="mb-input" type="email" value={email} placeholder="name@rada.gov.ua" aria-label={t('membersPage.inviteEmail')} disabled={!available}
          onChange={(e) => { setEmail(e.target.value); setError(''); }} />
      </label>
      <label className="mb-field">
        <span className="mb-field__label">{t('membersPage.role')}</span>
        <select className="mb-select mb-select--form" value={role} disabled={!available} onChange={(e) => setRole(e.target.value)}>
          {ROLES.map((r) => <option key={r} value={r}>{t(`membersPage.roleNames.${r}`, { defaultValue: r })}</option>)}
        </select>
      </label>
      <button type="submit" className="mb-send" disabled={!available || isLoading}>{t('membersPage.send')}</button>
      {error && <span className="mb-error" role="alert">{error}</span>}
      {!available && <span className="mb-note">{t('membersPage.unavailable')}</span>}
    </form>
  );
}
